import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { SharedService } from '../../../shared/shared.services';
import { AuthService } from '../../../authentication/oidc/auth.service';
import { SnackBarService } from '../../../shared/service/snack.bar.service';
import { UserService } from '../../../shared/service/user.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy {

  result: any;
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  superUser: boolean = false;

  private _mobileQueryListener: () => void;
  status: boolean = false;
  userMenuData: any = {};
  clickEvent() {
    this.status = !this.status;
  }

  subclickEvent() {
    this.status = true;
  }
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public sharedService: SharedService,
    public authService: AuthService,
    public userService: UserService,
    private snackBarSvc: SnackBarService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.superUser = this.authService.isSuperUser();
  }

  closeSideNav() {
    if (window.innerWidth < 768) {
      this.sharedService.sideNav.close();
    }
  }
  getSelect(current): boolean {
    let router = window.location.pathname.split('/')[1];
    return current == router;
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
